import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { API_URL } from '../config/api';
import {
  House,
  Users,
  FileText,
  CreditCard,
  SignOut,
  List,
  ClipboardText,
  Package,
  CalendarBlank,
  ChartBar,
  UsersThree,
  Receipt,
  Target,
  UserGear,
  Storefront,
  Money,
  Files,
  LinkSimple,
  MagnifyingGlass,
  Bell,
  X,
  Warning,
  Info,
  WarningCircle,
  Book,
  FunnelSimple,
  Briefcase,
  HardHat,
  CaretDown,
  Envelope,
  Phone,
  ChartLineUp,
  Binoculars,
  Key,
  Eye,
  EyeSlash,
  CheckCircle,
  Lightning,
  MapPin,
  Timer,
  CalendarCheck,
  Gauge,
  Robot,
  ChatCircleDots,
  Shield,
  ChartLine,
  Sparkle
} from '@phosphor-icons/react';

const STORAGE_KEYS = {
  collapsed: 'iqes_sidebar_collapsed',
  categories: 'iqes_sidebar_categories',
};

const ROLE_NAV = {
  admin: [
    { path: '/dashboard', label: 'Dashboard', icon: House },
    { path: '/executive', label: 'Scorecard', icon: Gauge },
    { path: '/activity', label: 'Actividad', icon: Lightning },
    { path: '/pipeline', label: 'Pipeline', icon: FunnelSimple },
    { path: '/leads', label: 'Leads', icon: Target },
    { path: '/clients', label: 'Clientes', icon: Users },
    { path: '/quotes', label: 'Cotizaciones', icon: FileText },
    { path: '/invoices', label: 'Facturas', icon: Receipt },
    { path: '/work-orders', label: 'Ordenes de Trabajo', icon: ClipboardText },
    { path: '/calendar', label: 'Calendario', icon: CalendarBlank },
    { path: '/technicians', label: 'Tecnicos', icon: UsersThree },
    { path: '/projects', label: 'Proyectos', icon: HardHat },
    { path: '/blueprints', label: 'Planos', icon: HardHat },
    { path: '/documents', label: 'Documentos', icon: Files },
    { path: '/payments', label: 'Pagos', icon: CreditCard },
    { path: '/task-manager', label: 'Tareas', icon: ClipboardText },
    { path: '/payment-links', label: 'Links de Pago', icon: LinkSimple },
    { path: '/payroll', label: 'Payroll', icon: Money },
    { path: '/prospects', label: 'Prospectos', icon: Briefcase },
    { path: '/call-candidates', label: 'Llamadas a Aprobar', icon: Phone },
    { path: '/campaigns', label: 'Campanas', icon: Envelope },
    { path: '/b2b-hub', label: 'B2B Centro', icon: ChartLineUp },
    { path: '/b2b-auto', label: 'B2B Config', icon: Robot },
    { path: '/portal-credentials', label: 'Credenciales Portales', icon: UserGear },
    { path: '/sales-agent', label: 'Agente de Ventas', icon: Robot },
    { path: '/market-intel', label: 'Inteligencia de Mercado', icon: Binoculars },
    { path: '/proposals', label: 'Propuestas IA', icon: FileText },
    { path: '/deal-strategy', label: 'Deal Strategist', icon: Target },
    { path: '/formats', label: 'Formatos del Sistema', icon: FileText },
    { path: '/post-sale', label: 'Post-Venta', icon: ClipboardText },
    { path: '/webhooks', label: 'Webhooks Salientes', icon: UserGear },
    { path: '/users', label: 'Usuarios', icon: UserGear },
    { path: '/inventory', label: 'Inventario', icon: Package },
    { path: '/catalog', label: 'Catalogo', icon: Storefront },
    { path: '/gps-tracking', label: 'GPS Tracking', icon: MapPin },
    { path: '/hrms', label: 'Control de Horas', icon: Timer },
    { path: '/reports', label: 'Reportes', icon: ChartBar },
    { path: '/daily-report', label: 'Reporte Diario', icon: Envelope },
    { path: '/campaign-tracking', label: 'Control y Seguimiento', icon: ChartLine },
    { path: '/ai-assistant', label: 'Asistente IA', icon: ChatCircleDots },
    { path: '/outreach-safety', label: 'Seguridad Outreach', icon: Shield },
    { path: '/campaign-metrics', label: 'Métricas Campañas', icon: ChartLine },
    { path: '/lead-gen-seo', label: 'Lead Gen + SEO', icon: Sparkle },
    { path: '/manual', label: 'Manual', icon: Book },
  ],
  manager: [
    { path: '/dashboard', label: 'Dashboard', icon: House },
    { path: '/executive', label: 'Scorecard', icon: Gauge },
    { path: '/pipeline', label: 'Pipeline', icon: FunnelSimple },
    { path: '/leads', label: 'Leads', icon: Target },
    { path: '/clients', label: 'Clientes', icon: Users },
    { path: '/quotes', label: 'Cotizaciones', icon: FileText },
    { path: '/invoices', label: 'Facturas', icon: Receipt },
    { path: '/work-orders', label: 'Ordenes de Trabajo', icon: ClipboardText },
    { path: '/calendar', label: 'Calendario', icon: CalendarBlank },
    { path: '/technicians', label: 'Tecnicos', icon: UsersThree },
    { path: '/projects', label: 'Proyectos', icon: HardHat },
    { path: '/payments', label: 'Pagos', icon: CreditCard },
    { path: '/payment-links', label: 'Links de Pago', icon: LinkSimple },
    { path: '/payroll', label: 'Payroll', icon: Money },
    { path: '/prospects', label: 'Prospectos', icon: Briefcase },
    { path: '/call-candidates', label: 'Llamadas a Aprobar', icon: Phone },
    { path: '/campaigns', label: 'Campanas', icon: Envelope },
    { path: '/b2b-reports', label: 'Reportes B2B', icon: ChartLineUp },
    { path: '/market-intel', label: 'Inteligencia de Mercado', icon: Binoculars },
    { path: '/users', label: 'Usuarios', icon: UserGear },
    { path: '/inventory', label: 'Inventario', icon: Package },
    { path: '/catalog', label: 'Catalogo', icon: Storefront },
    { path: '/documents', label: 'Documentos', icon: Files },
    { path: '/gps-tracking', label: 'GPS Tracking', icon: MapPin },
    { path: '/hrms', label: 'Control de Horas', icon: Timer },
    { path: '/reports', label: 'Reportes', icon: ChartBar },
    { path: '/ai-assistant', label: 'Asistente IA', icon: ChatCircleDots },
    { path: '/manual', label: 'Manual', icon: Book },
  ],
  sales: [
    { path: '/dashboard', label: 'Dashboard', icon: House },
    { path: '/pipeline', label: 'Pipeline', icon: FunnelSimple },
    { path: '/leads', label: 'Leads', icon: Target },
    { path: '/clients', label: 'Clientes', icon: Users },
    { path: '/quotes', label: 'Cotizaciones', icon: FileText },
    { path: '/invoices', label: 'Facturas', icon: Receipt },
    { path: '/catalog', label: 'Catalogo', icon: Storefront },
    { path: '/calendar', label: 'Calendario', icon: CalendarBlank },
    { path: '/payments', label: 'Pagos', icon: CreditCard },
    { path: '/payment-links', label: 'Links de Pago', icon: LinkSimple },
    { path: '/reports', label: 'Reportes', icon: ChartBar },
    { path: '/prospects', label: 'Prospectos', icon: Briefcase },
    { path: '/call-candidates', label: 'Llamadas a Aprobar', icon: Phone },
    { path: '/campaigns', label: 'Campanas', icon: Envelope },
    { path: '/b2b-reports', label: 'Reportes B2B', icon: ChartLineUp },
    { path: '/projects', label: 'Proyectos', icon: HardHat },
    { path: '/ai-assistant', label: 'Asistente IA', icon: ChatCircleDots },
    { path: '/manual', label: 'Manual', icon: Book },
  ],
  technician: [
    { path: '/tech-dashboard', label: 'Mi Panel', icon: House },
    { path: '/work-orders', label: 'Mis Ordenes', icon: ClipboardText },
    { path: '/calendar', label: 'Calendario', icon: CalendarBlank },
    { path: '/inventory', label: 'Inventario', icon: Package },
    { path: '/projects', label: 'Proyectos', icon: HardHat },
    { path: '/hrms', label: 'Control de Horas', icon: Timer },
    { path: '/ai-assistant', label: 'Asistente IA', icon: ChatCircleDots },
    { path: '/manual', label: 'Manual', icon: Book },
  ],
  engineer: [
    { path: '/dashboard', label: 'Dashboard', icon: House },
    { path: '/clients', label: 'Clientes', icon: Users },
    { path: '/work-orders', label: 'Ordenes de Trabajo', icon: ClipboardText },
    { path: '/calendar', label: 'Calendario', icon: CalendarBlank },
    { path: '/technicians', label: 'Tecnicos', icon: UsersThree },
    { path: '/projects', label: 'Proyectos', icon: HardHat },
    { path: '/inventory', label: 'Inventario', icon: Package },
    { path: '/documents', label: 'Documentos', icon: Files },
    { path: '/hrms', label: 'Control de Horas', icon: Timer },
    { path: '/reports', label: 'Reportes', icon: ChartBar },
    { path: '/ai-assistant', label: 'Asistente IA', icon: ChatCircleDots },
    { path: '/manual', label: 'Manual', icon: Book },
  ],
};

const SIDEBAR_CATEGORIES = [
  {
    key: 'dashboard',
    icon: House,
    paths: ['/dashboard', '/tech-dashboard', '/executive'],
    direct: true,
    separatorAfter: false,
  },
  {
    key: 'activity',
    icon: Lightning,
    paths: ['/activity'],
    direct: true,
    separatorAfter: true,
  },
  {
    key: 'crm',
    label: 'CRM',
    icon: FunnelSimple,
    paths: ['/pipeline', '/leads', '/clients', '/quotes'],
  },
  {
    key: 'operations',
    label: 'Operaciones',
    icon: ClipboardText,
    paths: ['/work-orders', '/calendar', '/technicians', '/gps-tracking'],
  },
  {
    key: 'construction',
    label: 'Proyectos',
    icon: HardHat,
    paths: ['/projects', '/blueprints', '/documents'],
    separatorAfter: true,
  },
  {
    key: 'finance',
    label: 'Finanzas',
    icon: Receipt,
    paths: ['/invoices', '/payments', '/payment-links', '/payroll'],
  },
  {
    key: 'b2b',
    label: 'Prospeccion B2B',
    icon: Briefcase,
    paths: ['/prospects', '/call-candidates', '/campaigns', '/b2b-hub', '/b2b-reports', '/b2b-auto', '/portal-credentials', '/sales-agent', '/market-intel', '/proposals', '/deal-strategy', '/post-sale'],
    separatorAfter: true,
  },
  {
    key: 'hrms',
    label: 'Recursos Humanos',
    icon: Timer,
    paths: ['/hrms'],
  },
  {
    key: 'admin',
    label: 'Administracion',
    icon: UserGear,
    paths: ['/users', '/inventory', '/catalog', '/formats', '/webhooks', '/reports', '/daily-report', '/campaign-tracking', '/manual'],
  },
];

const ROLE_LABELS = {
  admin: 'Administrador',
  manager: 'Gerente',
  sales: 'Vendedor',
  engineer: 'Ingeniero',
  technician: 'Tecnico',
};

const TYPE_ICONS = {
  client: Users,
  quote: FileText,
  invoice: Receipt,
  work_order: ClipboardText,
  lead: Target,
};

const TYPE_COLORS = {
  client: 'text-blue-600 bg-blue-50',
  quote: 'text-purple-600 bg-purple-50',
  invoice: 'text-green-600 bg-green-50',
  work_order: 'text-orange-600 bg-orange-50',
  lead: 'text-pink-600 bg-pink-50',
};

const TYPE_LABELS = {
  client: 'Cliente',
  quote: 'Cotizacion',
  invoice: 'Factura',
  work_order: 'Orden',
  lead: 'Lead',
};

const PATH_TO_PERMISSION = {
  '/dashboard': 'dashboard',
  '/executive': 'dashboard',
  '/pipeline': 'pipeline',
  '/leads': 'leads',
  '/clients': 'clients',
  '/quotes': 'quotes',
  '/invoices': 'invoices',
  '/work-orders': 'work_orders',
  '/calendar': 'calendar',
  '/inventory': 'inventory',
  '/technicians': 'technicians',
  '/catalog': 'catalog',
  '/payments': 'payments',
  '/payment-links': 'payment_links',
  '/payroll': 'payroll',
  '/documents': 'documents',
  '/reports': 'reports',
  '/users': 'users',
  '/prospects': 'prospects',
  '/call-candidates': 'prospects',
  '/campaigns': 'prospects',
  '/b2b-reports': 'prospects',
  '/b2b-hub': 'prospects',
  '/b2b-auto': 'prospects',
  '/sales-agent': 'prospects',
  '/market-intel': 'prospects',
  '/proposals': 'prospects',
  '/deal-strategy': 'prospects',
  '/post-sale': 'prospects',
  '/projects': 'projects',
  '/blueprints': 'construction',
  '/task-manager': 'construction',
  '/manual': 'manual',
  '/tech-dashboard': 'tech_dashboard',
};

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEYS.collapsed) === 'true'; }
    catch { return false; }
  });
  const [expandedCategories, setExpandedCategories] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEYS.categories);
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notifCount, setNotifCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [toasts, setToasts] = useState([]);
  const searchRef = useRef(null);
  const notifRef = useRef(null);
  const searchTimeout = useRef(null);
  const sseRef = useRef(null);

  // Password change state
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [pwForm, setPwForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [pwError, setPwError] = useState('');
  const [pwSuccess, setPwSuccess] = useState('');
  const [pwLoading, setPwLoading] = useState(false);
  const [showCurrentPw, setShowCurrentPw] = useState(false);
  const [showNewPw, setShowNewPw] = useState(false);

  const userRole = user?.role || 'admin';
  const roleNav = ROLE_NAV[userRole] || ROLE_NAV.admin;

  const navItems = user?.permissions?.length > 0
    ? roleNav.filter(item => {
        const perm = PATH_TO_PERMISSION[item.path];
        return !perm || user.permissions.includes(perm);
      })
    : roleNav;

  // On mobile when sidebar is open, always show expanded
  const showCollapsed = sidebarCollapsed && !sidebarOpen;

  const isPathActive = (path) => {
    if (path === '/dashboard' || path === '/tech-dashboard') {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  // Auto-expand category containing the active route + persist
  useEffect(() => {
    const currentPath = location.pathname;
    const activeCat = SIDEBAR_CATEGORIES.find(cat =>
      !cat.direct && cat.paths.some(p =>
        currentPath === p || currentPath.startsWith(p + '/')
      )
    );
    if (activeCat) {
      setExpandedCategories(prev => {
        const next = { ...prev, [activeCat.key]: true };
        try { localStorage.setItem(STORAGE_KEYS.categories, JSON.stringify(next)); } catch {}
        return next;
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, []);

  // SSE connection for real-time notifications
  useEffect(() => {
    if (!user) return;

    const connectSSE = () => {
      if (sseRef.current) {
        sseRef.current.close();
      }

      const eventSource = new EventSource(`${API_URL}/api/notifications/stream`, { withCredentials: true });
      sseRef.current = eventSource;

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'new_lead') {
            // Add toast notification
            const toast = {
              id: Date.now(),
              title: data.title,
              message: data.message,
              score: data.lead_score,
              source: data.source,
              assigned: data.assigned_to,
              leadId: data.lead_id
            };
            setToasts(prev => [toast, ...prev].slice(0, 5));

            // Auto-remove toast after 8 seconds
            setTimeout(() => {
              setToasts(prev => prev.filter(t => t.id !== toast.id));
            }, 8000);

            // Refresh notifications
            fetchNotifications();

            // Play notification sound
            try {
              const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbsGczGjhrl8DR1KJWMB9Sj7bGyK5nTjEcUY28x8WsaD8eMUl5tce3dl5AIjJLdbvIxXRtTzQeSXSxxcl1c14/JTVUYJ+xv8mpXkA0Kk55lLjFyIRJJ0Z0l8zUqVkrH0RJj625yMJ7UzcbSn+rv8KcaEI6S3u0yMh+XUIoQXq0z8V6WT8SN09yrMzVrls0HUR0pL/FzKNYKBdEd6jDx6VaLBo9cKO8v6RfKBY7daW8vKBWJx9MiLHDyZ1OJCdblcPUxIk9FDVKY5i918VxSiITNlFrn8jWsGk6GjFVcp/F1blqOBcwVnKfxda5ajgXMFZyn8XWuWo4FzBWcA==');
              audio.volume = 0.3;
              audio.play().catch(() => {});
            } catch {}
          }
        } catch {}
      };

      eventSource.onerror = () => {
        eventSource.close();
        // Reconnect after 30 seconds with backoff
        setTimeout(connectSSE, 30000);
      };
    };

    // Delay initial SSE connection to allow page to load
    const sseTimeout = setTimeout(connectSSE, 5000);

    return () => {
      clearTimeout(sseTimeout);
      if (sseRef.current) {
        sseRef.current.close();
      }
    };
  }, [user]);

  useEffect(() => {
    const handler = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) setShowSearch(false);
      if (notifRef.current && !notifRef.current.contains(e.target)) setShowNotifications(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/notifications`, { withCredentials: true });
      setNotifications(res.data.notifications || []);
      setNotifCount(res.data.count || 0);
    } catch {
      // silently fail
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    if (value.length < 2) {
      setSearchResults([]);
      setShowSearch(false);
      return;
    }
    searchTimeout.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${API_URL}/api/search?q=${encodeURIComponent(value)}`, { withCredentials: true });
        setSearchResults(res.data.results || []);
        setShowSearch(true);
      } catch {
        setSearchResults([]);
      }
    }, 300);
  };

  const handleSearchNavigate = (url) => {
    setShowSearch(false);
    setSearchQuery('');
    navigate(url);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleChangePassword = async () => {
    setPwError(''); setPwSuccess('');
    if (!pwForm.current_password || !pwForm.new_password) {
      setPwError('Todos los campos son requeridos'); return;
    }
    if (pwForm.new_password.length < 6) {
      setPwError('La nueva contrasena debe tener al menos 6 caracteres'); return;
    }
    if (pwForm.new_password !== pwForm.confirm_password) {
      setPwError('Las contrasenas no coinciden'); return;
    }
    setPwLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/change-password`, {
        current_password: pwForm.current_password,
        new_password: pwForm.new_password,
      }, { withCredentials: true });
      setPwSuccess('Contrasena actualizada exitosamente');
      setPwForm({ current_password: '', new_password: '', confirm_password: '' });
      setTimeout(() => { setShowPasswordModal(false); setPwSuccess(''); }, 2000);
    } catch (err) {
      setPwError(err.response?.data?.detail || 'Error al cambiar contrasena');
    } finally { setPwLoading(false); }
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEYS.collapsed, String(next)); } catch {}
      return next;
    });
  };

  const toggleCategory = (key) => {
    setExpandedCategories(prev => {
      const next = { ...prev, [key]: !prev[key] };
      try { localStorage.setItem(STORAGE_KEYS.categories, JSON.stringify(next)); } catch {}
      return next;
    });
  };

  const NotifIcon = ({ type }) => {
    if (type === 'danger') return <WarningCircle size={18} className="text-red-500" weight="fill" />;
    if (type === 'warning') return <Warning size={18} className="text-yellow-500" weight="fill" />;
    return <Info size={18} className="text-blue-500" weight="fill" />;
  };

  // --- Render helpers for collapsed sidebar ---
  const renderCollapsedDirect = (categoryItems) => {
    const item = categoryItems[0];
    const Icon = item.icon;
    const isActive = isPathActive(item.path);
    return (
      <div className="relative group px-2 mb-0.5">
        <Link
          to={item.path}
          className={`flex items-center justify-center p-2.5 rounded-lg transition-colors ${
            isActive ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'
          }`}
          data-testid={`nav-${item.path.replace(/\//g, '')}`}
        >
          <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
        </Link>
        <div className="absolute left-full top-1/2 -translate-y-1/2 hidden group-hover:block z-[60] pl-2 pointer-events-none">
          <div className="bg-slate-800 rounded-md shadow-lg border border-slate-700/80 px-3 py-1.5 text-sm text-white whitespace-nowrap">
            {item.label}
          </div>
        </div>
      </div>
    );
  };

  const renderCollapsedCategory = (category, categoryItems, hasActiveItem) => {
    const CategoryIcon = category.icon;
    return (
      <div className="relative group px-2 mb-0.5">
        <div
          className={`flex items-center justify-center p-2.5 rounded-lg cursor-pointer transition-colors ${
            hasActiveItem ? 'bg-blue-600/20 text-blue-400' : 'text-slate-400 hover:text-white hover:bg-slate-800'
          }`}
          data-testid={`nav-category-${category.key}`}
        >
          <CategoryIcon size={20} weight={hasActiveItem ? 'fill' : 'regular'} />
        </div>
        <div className="absolute left-full top-0 hidden group-hover:block z-[60] pl-2">
          <div className="bg-slate-800 rounded-lg shadow-2xl border border-slate-700/80 py-1 min-w-[180px]">
            <div className="px-3 py-2 text-xs font-semibold text-slate-400 border-b border-slate-700/50">
              {category.label}
            </div>
            {categoryItems.map(item => {
              const Icon = item.icon;
              const isActive = isPathActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2.5 px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? 'text-blue-400 bg-blue-500/15 font-medium'
                      : 'text-slate-300 hover:text-white hover:bg-slate-700/50'
                  }`}
                  data-testid={`nav-${item.path.replace(/\//g, '')}`}
                >
                  <Icon size={15} weight={isActive ? 'fill' : 'regular'} />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  // --- Render helpers for expanded sidebar ---
  const renderExpandedDirect = (categoryItems) => (
    <div className="px-2 mb-0.5">
      {categoryItems.map(item => {
        const Icon = item.icon;
        const isActive = isPathActive(item.path);
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`sidebar-link ${isActive ? 'active' : ''}`}
            data-testid={`nav-${item.path.replace(/\//g, '')}`}
          >
            <Icon size={20} weight={isActive ? 'fill' : 'regular'} />
            <span className="font-medium text-sm">{item.label}</span>
          </Link>
        );
      })}
    </div>
  );

  const renderExpandedCategory = (category, categoryItems, hasActiveItem, isExpanded) => {
    const CategoryIcon = category.icon;
    return (
      <div className="mb-0.5">
        <button
          onClick={() => toggleCategory(category.key)}
          className={`w-full flex items-center gap-3 px-4 py-2 text-sm transition-all duration-150 group cursor-pointer ${
            hasActiveItem ? 'text-white' : 'text-slate-400 hover:text-slate-200'
          }`}
          data-testid={`nav-category-${category.key}`}
        >
          <CategoryIcon
            size={18}
            weight={hasActiveItem ? 'fill' : 'regular'}
            className={`transition-colors ${hasActiveItem ? 'text-blue-400' : 'text-slate-500 group-hover:text-slate-300'}`}
          />
          <span className="font-semibold flex-1 text-left">{category.label}</span>
          <CaretDown
            size={12}
            className={`transition-transform duration-200 opacity-50 ${isExpanded ? '' : '-rotate-90'}`}
          />
        </button>
        <div
          className={`overflow-hidden transition-all duration-200 ease-in-out ${
            isExpanded ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="pb-1 ml-5 mr-2 border-l border-slate-700/40">
            {categoryItems.map(item => {
              const Icon = item.icon;
              const isActive = isPathActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2.5 pl-4 pr-3 py-[7px] rounded-r-md text-[13px] transition-all duration-150 ${
                    isActive
                      ? 'text-blue-400 bg-blue-500/10 border-l-2 border-blue-400 -ml-px font-medium'
                      : 'text-slate-400 hover:text-slate-100 hover:bg-slate-800/40'
                  }`}
                  data-testid={`nav-${item.path.replace(/\//g, '')}`}
                >
                  <Icon size={15} weight={isActive ? 'fill' : 'regular'} />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-50
          w-64 ${sidebarCollapsed ? 'lg:w-[68px]' : ''}
          bg-slate-900 text-white flex-shrink-0
          transform transition-all duration-200 ease-in-out
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
        data-testid="sidebar"
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          {showCollapsed ? (
            <div className="p-2 border-b border-slate-700/60">
              <div className="flex flex-col items-center gap-1.5 py-1">
                <img
                  src="https://customer-assets.emergentagent.com/job_0246dde3-e1c1-4ddd-b1f0-cbdadc084ea8/artifacts/indb97if_WhatsApp%20Image%202026-02-08%20at%208.04.43%20PM%20%281%29.jpeg"
                  alt="IQES"
                  className="w-9 h-9 rounded-lg object-contain bg-white p-0.5"
                />
                <button
                  onClick={toggleSidebarCollapse}
                  className="p-1 rounded text-slate-500 hover:text-white hover:bg-slate-800 transition-colors"
                  data-testid="sidebar-expand-toggle"
                  title="Expandir menu"
                >
                  <CaretDown size={12} className="-rotate-90" />
                </button>
              </div>
            </div>
          ) : (
            <div className="p-4 lg:p-5 border-b border-slate-700/60">
              <div className="flex items-center gap-3">
                <img
                  src="https://customer-assets.emergentagent.com/job_0246dde3-e1c1-4ddd-b1f0-cbdadc084ea8/artifacts/indb97if_WhatsApp%20Image%202026-02-08%20at%208.04.43%20PM%20%281%29.jpeg"
                  alt="IQES Logo"
                  className="w-10 h-10 rounded-lg object-contain bg-white p-1"
                />
                <div className="min-w-0">
                  <h1 className="font-bold text-lg">IQES CRM</h1>
                  <p className="text-xs text-slate-400">Low Voltage Solutions</p>
                </div>
                <button
                  onClick={() => setSidebarOpen(false)}
                  className="ml-auto lg:hidden p-1 hover:bg-slate-800 rounded"
                >
                  <X size={20} />
                </button>
                <button
                  onClick={toggleSidebarCollapse}
                  className="ml-auto hidden lg:flex items-center justify-center p-1.5 rounded-md text-slate-500 hover:text-white hover:bg-slate-700 transition-colors"
                  data-testid="sidebar-collapse-toggle"
                  title="Colapsar menu"
                >
                  <CaretDown size={14} className="rotate-90" />
                </button>
              </div>
            </div>
          )}

          {/* Navigation */}
          <nav
            className={`flex-1 pt-3 pb-2 ${showCollapsed ? 'overflow-visible' : 'overflow-y-auto'}`}
            data-testid="sidebar-nav"
          >
            {SIDEBAR_CATEGORIES.map((category) => {
              const categoryItems = navItems.filter(item => category.paths.includes(item.path));
              if (categoryItems.length === 0) return null;

              const isExpanded = expandedCategories[category.key];
              const hasActiveItem = categoryItems.some(item => isPathActive(item.path));

              return (
                <div key={category.key}>
                  {category.direct
                    ? (showCollapsed ? renderCollapsedDirect(categoryItems) : renderExpandedDirect(categoryItems))
                    : (showCollapsed
                        ? renderCollapsedCategory(category, categoryItems, hasActiveItem)
                        : renderExpandedCategory(category, categoryItems, hasActiveItem, isExpanded)
                      )
                  }
                  {category.separatorAfter && (
                    <div className={`my-2 border-t border-slate-700/40 ${showCollapsed ? 'mx-2' : 'mx-4'}`} />
                  )}
                </div>
              );
            })}
          </nav>

          {/* User info & Logout */}
          {showCollapsed ? (
            <div className="p-2 border-t border-slate-700/60">
              <div className="flex flex-col items-center gap-1">
                <div
                  className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center font-bold text-sm cursor-default"
                  title={`${user?.name || 'Admin'} - ${ROLE_LABELS[userRole] || userRole}`}
                >
                  {user?.name?.charAt(0) || 'A'}
                </div>
                <button
                  onClick={handleLogout}
                  className="p-2 text-slate-300 hover:bg-slate-800 hover:text-white rounded-lg transition-colors"
                  data-testid="logout-button"
                  title="Cerrar sesion"
                >
                  <SignOut size={18} />
                </button>
              </div>
            </div>
          ) : (
            <div className="p-3 border-t border-slate-700/60">
              <div className="flex items-center gap-3 px-3 py-2 mb-1">
                <div className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center font-bold text-sm">
                  {user?.name?.charAt(0) || 'A'}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate">{user?.name || 'Admin'}</p>
                  <p className="text-xs text-slate-400 truncate">{ROLE_LABELS[userRole] || userRole}</p>
                </div>
              </div>
              <button
                onClick={() => { setShowPasswordModal(true); setPwError(''); setPwSuccess(''); }}
                className="w-full flex items-center gap-3 px-4 py-2 text-slate-300 hover:bg-slate-800 hover:text-white rounded-lg transition-colors text-sm mb-1"
                data-testid="change-password-button"
              >
                <Key size={18} />
                <span>Cambiar Contrasena</span>
              </button>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-2 text-slate-300 hover:bg-slate-800 hover:text-white rounded-lg transition-colors text-sm"
                data-testid="logout-button"
              >
                <SignOut size={18} />
                <span>Cerrar sesion</span>
              </button>
            </div>
          )}
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Top header */}
        <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b border-slate-200 px-3 lg:px-8 py-3">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden p-2 hover:bg-slate-100 rounded-lg"
              data-testid="mobile-menu-button"
            >
              <List size={24} />
            </button>

            <h2 className="text-base lg:text-lg font-semibold text-slate-900 hidden sm:block">
              {navItems.find(item => location.pathname === item.path || location.pathname.startsWith(item.path + '/'))?.label || 'CRM'}
            </h2>

            {/* Global Search */}
            <div className="flex-1 max-w-md ml-auto relative" ref={searchRef}>
              <div className="relative">
                <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="Buscar clientes, cotizaciones, ordenes..."
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  onFocus={() => searchQuery.length >= 2 && setShowSearch(true)}
                  className="w-full pl-10 pr-4 py-2 bg-slate-100 border border-transparent rounded-lg text-sm focus:bg-white focus:border-slate-300 focus:ring-1 focus:ring-blue-500 transition-colors"
                  data-testid="global-search-input"
                />
              </div>
              {showSearch && searchResults.length > 0 && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden max-h-80 overflow-y-auto z-50" data-testid="search-results-dropdown">
                  {searchResults.map((r, i) => {
                    const Icon = TYPE_ICONS[r.type] || FileText;
                    const colorClass = TYPE_COLORS[r.type] || 'text-slate-600 bg-slate-50';
                    return (
                      <button
                        key={i}
                        onClick={() => handleSearchNavigate(r.url)}
                        className="w-full flex items-center gap-3 px-4 py-3 hover:bg-slate-50 transition-colors text-left border-b border-slate-100 last:border-0"
                      >
                        <div className={`p-2 rounded-lg ${colorClass}`}>
                          <Icon size={16} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-slate-900 truncate">{r.title}</p>
                          <p className="text-xs text-slate-500 truncate">{r.subtitle}</p>
                        </div>
                        <span className="text-xs text-slate-400 shrink-0">{TYPE_LABELS[r.type]}</span>
                      </button>
                    );
                  })}
                </div>
              )}
              {showSearch && searchResults.length === 0 && searchQuery.length >= 2 && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-xl shadow-xl border border-slate-200 p-4 text-center text-sm text-slate-500 z-50">
                  Sin resultados para "{searchQuery}"
                </div>
              )}
            </div>

            {/* Notifications Bell */}
            <div className="relative" ref={notifRef}>
              <button
                onClick={() => { setShowNotifications(!showNotifications); }}
                className="relative p-2 hover:bg-slate-100 rounded-lg transition-colors"
                data-testid="notifications-bell"
              >
                <Bell size={22} className="text-slate-600" />
                {notifCount > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center" data-testid="notif-count">
                    {notifCount > 9 ? '9+' : notifCount}
                  </span>
                )}
              </button>
              {showNotifications && (
                <div className="absolute right-0 top-full mt-1 w-80 sm:w-96 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden z-50" data-testid="notifications-dropdown">
                  <div className="px-4 py-3 border-b border-slate-200 bg-slate-50">
                    <h3 className="font-semibold text-sm text-slate-900">Notificaciones ({notifCount})</h3>
                  </div>
                  <div className="max-h-80 overflow-y-auto">
                    {notifications.length === 0 ? (
                      <div className="p-6 text-center text-sm text-slate-500">Todo en orden</div>
                    ) : (
                      notifications.map((n, i) => (
                        <Link
                          key={i}
                          to={n.url}
                          onClick={() => setShowNotifications(false)}
                          className="flex items-start gap-3 px-4 py-3 hover:bg-slate-50 transition-colors border-b border-slate-100 last:border-0"
                        >
                          <NotifIcon type={n.type} />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-slate-900">{n.title}</p>
                            <p className="text-xs text-slate-500 mt-0.5">{n.message}</p>
                          </div>
                        </Link>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 p-3 sm:p-4 lg:p-8 overflow-auto">
          {children}
        </main>
      </div>

      {/* Password Change Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4" onClick={() => setShowPasswordModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()} data-testid="password-change-modal">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Key size={22} className="text-blue-600" /> Cambiar Contrasena</h2>
              <button onClick={() => setShowPasswordModal(false)} className="p-1.5 hover:bg-slate-100 rounded-lg"><X size={18} /></button>
            </div>
            <div className="p-5 space-y-4">
              {pwError && <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700" data-testid="pw-error">{pwError}</div>}
              {pwSuccess && <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3 text-sm text-emerald-700 flex items-center gap-2" data-testid="pw-success"><CheckCircle size={18} weight="fill" /> {pwSuccess}</div>}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Contrasena Actual</label>
                <div className="relative">
                  <input
                    type={showCurrentPw ? 'text' : 'password'}
                    value={pwForm.current_password}
                    onChange={e => setPwForm(p => ({...p, current_password: e.target.value}))}
                    className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 pr-10"
                    placeholder="Tu contrasena actual"
                    data-testid="current-password-input"
                  />
                  <button type="button" onClick={() => setShowCurrentPw(!showCurrentPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                    {showCurrentPw ? <EyeSlash size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Nueva Contrasena</label>
                <div className="relative">
                  <input
                    type={showNewPw ? 'text' : 'password'}
                    value={pwForm.new_password}
                    onChange={e => setPwForm(p => ({...p, new_password: e.target.value}))}
                    className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 pr-10"
                    placeholder="Minimo 6 caracteres"
                    data-testid="new-password-input"
                  />
                  <button type="button" onClick={() => setShowNewPw(!showNewPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                    {showNewPw ? <EyeSlash size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Confirmar Nueva Contrasena</label>
                <input
                  type="password"
                  value={pwForm.confirm_password}
                  onChange={e => setPwForm(p => ({...p, confirm_password: e.target.value}))}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                  placeholder="Repite la nueva contrasena"
                  data-testid="confirm-password-input"
                />
              </div>
            </div>
            <div className="flex gap-2 p-5 pt-0">
              <button onClick={() => setShowPasswordModal(false)} className="flex-1 px-4 py-2.5 border border-slate-200 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-50">Cancelar</button>
              <button
                onClick={handleChangePassword}
                disabled={pwLoading}
                className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
                data-testid="save-password-btn"
              >
                {pwLoading ? 'Guardando...' : 'Guardar Contrasena'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Real-time Toast Notifications */}
      {toasts.length > 0 && (
        <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 max-w-sm" data-testid="toast-container">
          {toasts.map((toast) => (
            <div
              key={toast.id}
              className="bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden animate-slide-in-right"
              data-testid={`toast-${toast.id}`}
              style={{
                animation: 'slideInRight 0.4s ease-out'
              }}
            >
              <div className="bg-gradient-to-r from-green-500 to-emerald-500 h-1" />
              <div className="p-4">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                      <Bell size={16} className="text-green-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-slate-900">{toast.title}</p>
                      <p className="text-xs text-slate-500 mt-0.5">{toast.message}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
                    className="text-slate-400 hover:text-slate-600 p-0.5"
                  >
                    <X size={14} />
                  </button>
                </div>
                <div className="flex items-center gap-3 mt-2 ml-10">
                  {toast.score !== undefined && (
                    <span className={`text-xs font-semibold px-1.5 py-0.5 rounded ${toast.score >= 70 ? 'bg-green-100 text-green-700' : toast.score >= 40 ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`}>
                      Score: {toast.score}
                    </span>
                  )}
                  {toast.assigned && (
                    <span className="text-xs text-blue-600">Asignado: {toast.assigned}</span>
                  )}
                </div>
                <button
                  onClick={() => {
                    navigate('/leads');
                    setToasts(prev => prev.filter(t => t.id !== toast.id));
                  }}
                  className="ml-10 mt-2 text-xs font-medium text-blue-600 hover:text-blue-700"
                >
                  Ver Lead →
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
